module.exports = __webpack_public_path__ + "img/ico-lock-padlock.784a7bca.svg";